import Divider from '@mui/material/Divider';
import { styled, alpha } from '@mui/material/styles';

const StyledDivider = styled(Divider)(({ theme }) => ({
    backgroundColor: alpha(theme.palette.common.white, 0.6)
}));

export default StyledDivider;
